import styled from "styled-components";
import { FlexRow } from "styles/layout";

export const MatchTeamsContainer = styled.div`
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: clip;
`;

export const MatchTeamContainer = styled(FlexRow)`
  padding: 1px 0;
`;

export const OrgLogoContainer = styled.div`
  min-width: 22px;
  max-width: 22px;
  height: 24px;
`;

export const OrgName = styled.div`
  margin-left: 10px;
  max-width: 99%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: clip;
`;

export const TeamScore = styled.div`
  width: 25px;
  min-width: fit-content;
  padding-left: 4px;
  text-align: right;
  margin-left: auto;
`;
